// extracted by mini-css-extract-plugin
export const full_bleed = "index-module--full_bleed--v_6SJ";
export const skills = "index-module--skills--2bBoZ";
export const footerIconLink = "index-module--footerIconLink--39_tC";